export const convertHomeString = (name: string | undefined): string =>
  name || "自宅";

export const convertPriceString = (price: number): string =>
  price === undefined || price === 0 ? "" : `(${price} 円)`;
